import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import { Button } from "react-bootstrap";
import moment from "moment";
import useAttendance from "../Staff-info/CheckIn&CheckOut";
import YourTasks from "../Services/YourTask";
import ServiceModal from "../Services/CreateService";
import Select from "react-select";

export default function StaffDashboard() {
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [lists, setLists] = useState([]);
  const [filterValues, setFilterValues] = useState({
    staffId: "00000000-0000-0000-0000-000000000000",
    clientId: "00000000-0000-0000-0000-000000000000",
    categoryId: "00000000-0000-0000-0000-000000000000",
    month: new Date(),
    status: "",
  });
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [pageNumber, setPageNumber] = useState(1);
  const [viewingYourTasks, setViewingYourTasks] = useState(false);
  const [clients, setClients] = useState([]);
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const { checkIn, checkOut } = useAttendance();
  const [errors, setErrors] = useState({ comment: null });
  const [showServiceModal, setShowServiceModal] = useState(false);
  const userId = localStorage.getItem("userId");
  const staffId = localStorage.getItem("staffId");

  const headerconfig = {
    headers: { Authorization: "Bearer " + localStorage.getItem("userToken") },
  };

  const handlefilterChange = (e) => {
    const { name, value } = e.target;
    setFilterValues({
      ...filterValues,
      [name]: value,
    });
  };
  const handleSearch = () => {
    GetData(pageNumber);
  };

  const handleclear = () => {
    GetData(pageNumber);
    setFilterValues({
      staffId: "00000000-0000-0000-0000-000000000000",
      clientId: "00000000-0000-0000-0000-000000000000",
      categoryId: "00000000-0000-0000-0000-000000000000",
      month: new Date(),
      status: "",
    });
  };
  const handleShowAllTasks = () => {
    setViewingYourTasks(false);
    GetData(pageNumber);
  };

  const GetPageData = (number) => {
    if (number >= 1 && number <= totalPages) {
      setPageNumber(number);
      GetData(number);
    }
  };
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const handleAcceptTask = (serviceTaskId) => {
    axios
      .put(
        config.APIACTIVATEURL +
          config.ACCEPTSERVICETASK +
          "/" +
          serviceTaskId +
          "/" +
          staffId,
        {},
        headerconfig
      )
      .then((response) => {
        if (response.data.statusCode === 200) {
          handleSuccess(response.data.data);
          GetData(pageNumber);
        } else {
          handleError(response.data.data);
        }
      });
  };
  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETALLSERVICETASKS +
          "?userId=" +
          userId +
          "&pageNumber=" +
          number +
          "&pageSize=" +
          pageSize +
          "&staffId=" +
          staffId +
          "&clientId=" +
          filterValues.clientId +
          "&categoryId=" +
          filterValues.categoryId +
          "&month=" +
          moment(filterValues.month).format("YYYY-MM") +
          "&status=" +
          filterValues.status,
        { ...headerconfig }
      )
      .then((response) => {
        setLists(response.data.data.data);
        setPageNumber(response.data.data.pageNumber);
        setPageSize(response.data.data.pageSize);
        setTotalPages(response.data.data.totalPages);
        setData(response.data.data);
        setTotalRecords(response.data.data.totalRecords);
      });
  };

  const GetClients = () => {
    axios
      .get(
        config.APIACTIVATEURL + config.GETALLCLIENTS + "?userId=" + userId,
        headerconfig
      )
      .then((response) => {
        setClients(response.data.data);
      });
  };

  const GetCategories = () => {
    axios
      .get(
        config.APIACTIVATEURL + config.GETBOTTOMLEVELCATEGORIES,
        headerconfig
      )
      .then((response) => {
        setCategories(response.data.data);
      });
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    GetData(pageNumber);
    GetClients();
    GetCategories();
  }, []);

  return (
    <div id="layout-wrapper">
      <LayoutHeader></LayoutHeader>
      <LayoutSideBar></LayoutSideBar>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Dashboard</h4>
                </div>
              </div>
            </div>
            <div className="row mb-3 pb-1">
              <div className="col-12">
                <div className="d-flex align-items-lg-center justify-content-between flex-wrap">
                  <div className="flex-grow-1">
                    <h4 className="fs-16 mb-1">
                      Good Morning{" "}
                      <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                        {localStorage.getItem("name")}
                      </span>
                    </h4>
                    <p className="text-muted mb-0">
                      Here's what's happening today.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-between mb-4">
              <div className="d-flex gap-4">
                <button
                  className="btn btn-primary"
                  onClick={handleShowAllTasks}
                >
                  All Tasks
                </button>
                <button
                  className="btn btn-warning text-white"
                  onClick={() => setViewingYourTasks(true)}
                >
                  Your Tasks
                </button>
                <div>
                  <Link to={"/clients"} className="btn btn-success">
                    {" "}
                    Create Client
                  </Link>
                </div>
                <button
                  className="btn btn-info text-white"
                  onClick={() => setShowServiceModal(true)}
                >
                  Create Service
                </button>
              </div>
              <div className="d-flex gap-4">
                <button
                  className="btn btn-secondary"
                  onClick={checkIn}
                  disabled={!btnSubmit}
                >
                  Check In
                </button>
                <button
                  className="btn btn-danger"
                  onClick={checkOut}
                  disabled={!btnSubmit}
                >
                  Check Out
                </button>
              </div>
            </div>

            {!viewingYourTasks && (
              <>
                <div className="alert alert-success">
                  <form autoComplete="off" noValidate>
                    <div className="row">
                      <div className="col-lg-3">
                        <div className="mb-3">
                          <label>Client</label>
                          <Select
                            name="clientId"
                            value={
                              clients.find(
                                (c) => c.clientId === filterValues.clientId
                              )
                                ? {
                                    value: filterValues.clientId,
                                    label:
                                      clients.find(
                                        (c) =>
                                          c.clientId === filterValues.clientId
                                      )?.clientName || "All",
                                  }
                                : null
                            }
                            onChange={(selectedOption) =>
                              setFilterValues({
                                ...filterValues,
                                clientId: selectedOption
                                  ? selectedOption.value
                                  : "00000000-0000-0000-0000-000000000000",
                              })
                            }
                            options={[
                              {
                                value: "00000000-0000-0000-0000-000000000000",
                                label: "All",
                              },
                              ...clients.map((c) => ({
                                value: c.clientId,
                                label: c.clientName,
                              })),
                            ]}
                            isSearchable
                            placeholder="Select Client"
                          />
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="mb-3">
                          <label htmlFor="categoryId" className="form-label">
                            Category
                          </label>
                          <select
                            name="categoryId"
                            value={filterValues.categoryId}
                            onChange={handlefilterChange}
                            className={
                              "form-select " + applyErrorClass("categoryId")
                            }
                          >
                            <option value="00000000-0000-0000-0000-000000000000">
                              All
                            </option>
                            {categories.map((c) => (
                              <option key={c.categoryId} value={c.categoryId}>
                                {c.categoryName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="mb-3">
                          <label>Month</label>
                          <div className="input-group">
                            <Flatpickr
                              value={filterValues.month}
                              className="form-control"
                              options={{
                                dateFormat: "Y-m",
                                plugins: [
                                  new (require("flatpickr/dist/plugins/monthSelect"))(
                                    {
                                      shorthand: true,
                                      dateFormat: "M-Y",
                                      theme: "light",
                                    }
                                  ),
                                ],
                              }}
                              onChange={(date) =>
                                setFilterValues({
                                  ...filterValues,
                                  month: date[0],
                                })
                              }
                            />
                            <div className="input-group-text bg-primary border-primary text-white">
                              <i className="ri-calendar-2-line" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="mb-3">
                          <label htmlFor="status" className="form-label">
                            Status
                          </label>
                          <select
                            name="status"
                            value={filterValues.status}
                            onChange={handlefilterChange}
                            className="form-select"
                          >
                            <option value="">All</option>
                            <option value="COMPLETED">COMPLETED</option>
                            <option value="PENDING">PENDING</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="hstack gap-2 justify-content-middle mb-3 mt-4">
                          <button
                            type="button"
                            className="btn btn-primary w-100"
                            onClick={handleSearch}
                          >
                            Search
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger w-100"
                            onClick={handleclear}
                          >
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="row">
                  <div className="col-xl-12">
                    <div className="card card-height-100">
                      <div className="card-header align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">
                          All Tasks
                        </h4>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive table-card">
                          <table
                            className="table align-middle"
                            id="customerTable"
                          >
                            <thead className="table-light">
                              <tr>
                                <th>S.No</th>
                                <th>Client</th>
                                <th>Service</th>
                                <th>Service Month</th>
                                <th>Cycle</th>
                                <th>Service Status</th>
                                <th>Created Date</th>
                                <th>Updated Date</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody className="list form-check-all">
                              {lists.length > 0 ? (
                                lists.map((v, index) => (
                                  <tr key={v.serviceTaskId}>
                                    <td>
                                      {(pageNumber - 1) * pageSize +
                                        (index + 1)}
                                    </td>
                                    <td>{v.clientName}</td>
                                    <td>{v.serviceName}</td>
                                    <td>
                                      {moment(v.month).format("MMM-YYYY")}
                                    </td>
                                    <td>{v.cycle}</td>
                                    <td>
                                      <span
                                        className={
                                          "badge " +
                                          (v.status === "COMPLETED"
                                            ? "bg-success"
                                            : "bg-warning")
                                        }
                                      >
                                        {v.status}
                                      </span>
                                    </td>
                                    <td>
                                      {moment(v.createdDate).format(
                                        "DD MMM YY hh:mm a"
                                      )}
                                    </td>
                                    <td>
                                      {moment(v.lastUpdatedDate).format(
                                        "DD MMM YY hh:mm a"
                                      )}
                                    </td>
                                    <td>
                                      <button
                                        className={
                                          "btn btn-sm " +
                                          (v.staffId ===
                                            "00000000-0000-0000-0000-000000000000" ||
                                          !v.staffId
                                            ? "btn-primary"
                                            : "btn-secondary")
                                        }
                                        onClick={() =>
                                          handleAcceptTask(v.serviceTaskId)
                                        }
                                        disabled={
                                          v.staffId &&
                                          v.staffId !==
                                            "00000000-0000-0000-0000-000000000000"
                                        }
                                      >
                                        {v.staffId &&
                                        v.staffId !==
                                          "00000000-0000-0000-0000-000000000000"
                                          ? v.staffId ===
                                            localStorage.getItem("staffId")
                                            ? "Accepted"
                                            : "Assigned"
                                          : "Accept"}
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="10" className="text-center">
                                    Not available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                          <div className="flex-shrink-0">
                            <div className="text-muted">
                              Showing{" "}
                              <span className="fw-semibold">
                                {lists.length}
                              </span>{" "}
                              of{" "}
                              <span className="fw-semibold">
                                {totalRecords}
                              </span>{" "}
                              Results
                            </div>
                          </div>
                          <ul className="pagination pagination-separated pagination-sm mb-0">
                            <li
                              className={
                                "page-item " +
                                (pageNumber === 1 ? "disabled" : "")
                              }
                              onClick={() => GetPageData(pageNumber - 1)}
                            >
                              <Link className="page-link">Previous</Link>
                            </li>
                            {renderPageNumbers}
                            <li
                              className={
                                "page-item " +
                                (pageNumber === totalPages ? "disabled" : "")
                              }
                              onClick={() => GetPageData(pageNumber + 1)}
                            >
                              <Link className="page-link">Next</Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {viewingYourTasks && (
              <YourTasks
                headerconfig={headerconfig}
                clients={clients}
                categories={categories}
              />
            )}
            <ServiceModal
              show={showServiceModal}
              onClose={() => setShowServiceModal(false)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
